var _excluded = ["color", "className"];
var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Logos/Logo.tsx",
  _this = this;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { IconLogoGoldie } from '@wds/icons';
import { Box } from '@wds/box';
import { WebAssetsThemeWrapper } from '../../theme';
var Logo = function Logo(props) {
  return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(LogoContent, Object.assign({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 5
    }
  })));
};
var LogoContent = function LogoContent(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    display: "inline-flex",
    className: className
  }, other, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(IconLogoGoldie, {
    title: "SurveyMonkey Logo",
    color: color === 'primary' ? 'primary' : 'light',
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }));
};
export default Logo;
//# sourceMappingURL=Logo.js.map